/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';

// Component imports
import { Divider, Form, Input, Typography } from 'antd';
import { t } from 'i18next';

// Constant declarations
const { Text } = Typography;

const HelviaNLPSpecificationProviderForm = () => {
  return (
    <Fragment>
      <Divider orientation="left" className="mb-8">
        <Text type="secondary" className="fs-base">{t('Provider Settings')}</Text>
      </Divider>

      <Form.Item
        label={t('Service URL')}
        name="serviceUrl"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        },
        {
          type: 'url',
          message: `${t('This field must be a valid url')}.`
        }]}
      >
        <Input placeholder={t('Enter the service url')} />
      </Form.Item>

      <Form.Item
        label={t('Access Token')}
        name="bearerToken"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input.TextArea
          autoSize={{ minRows: 6, maxRows: 6 }}
          rows={4}
          placeholder={t('Enter the access token')}
          allowClear
        />
      </Form.Item>
    </Fragment>
  );
};

export default HelviaNLPSpecificationProviderForm;
